// extracted by mini-css-extract-plugin
export default {"SegmentedControl":"BlobTabButtons-module__SegmentedControl--JMGov"};